import * as userRequest from "@/utils/userRequest";

export interface DepositSubPaymentPayload {
    amount: number;
    currency: string;
    username: string;
    slugCurrencyConvert: string;
    telegramId?: string;
}

export default async function depositWithSubPaymentService(
    data: DepositSubPaymentPayload,
    onSuccess?: (data?: any) => any,
    handleError?: (err?: any) => any
) {
    try {
        const res = await userRequest.post("/payment-gateway/request-deposit-with-sub-payment", {
            ...data,
        });

        if (res.success) {
            onSuccess && onSuccess(res);
            return res;
        }
        throw new Error(res.message);
    } catch (err) {
        console.error("🚀 ~ depositWithSubPaymentService ~ err:", err);
        handleError && handleError(err);
        throw err;
    }
}
